















































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { AxiosResponse } from "axios";
import { pics } from "@/config/host.config";
import { size, type } from "@/config/files.config.json";
import { splitString } from "@/services/strings";

@Component
class PosterEditor extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, required: true }) folder!: string;
  @Prop({ type: String, default: "" }) locale!: string;
  @Prop({ type: String, default: "hd" }) variant!: string;
  @Prop({ type: String, default: "/api/upload/new" }) host!: string;
  @Prop({ type: Number, default: 200 }) width!: number;
  @Prop({ type: Number, default: 300 }) height!: number;

  uploading = false;
  progress = 0;

  $refs!: {
    fileInput: HTMLInputElement;
  };

  get containerStyle(): Record<string, string> {
    return {
      width: `${this.width}px`,
      height: `${this.height}px`,
    };
  }

  get imageUrl(): string {
    if (!this.image) return "";
    const parts = [this.folder, this.locale, this.variant].filter(Boolean);
    return this.$getWebImage(this.image, parts.join("/"));
  }

  get fallbackImage(): string {
    return this.$getImage("empty.png", null) || "";
  }

  triggerUpload(): void {
    this.$refs.fileInput.click();
  }

  handleFileChange(): void {
    const file = this.$refs.fileInput.files
      ? this.$refs.fileInput.files[0]
      : null;
    if (!file) return;
    this.upload(file);
  }

  getFileFormat(mime: string | undefined): boolean {
    if (!mime) return false;
    const arr = splitString(mime, "/");
    return type.image.includes(arr[arr.length - 1]);
  }

  async upload(file: File): Promise<void> {
    if (!this.getFileFormat(file.type)) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("posterEditor.invalidType")),
        type: "warn",
      });
      return;
    }
    if (file.size > size.image) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("posterEditor.tooLarge")),
        type: "warn",
      });
      return;
    }

    this.uploading = true;
    this.progress = 0;

    const formData = new FormData();
    formData.append("poster", file);

    const params: Record<string, string> = { path: this.folder };
    if (this.locale) params.lang = this.locale;

    const config = {
      onUploadProgress: (event: ProgressEvent) => {
        this.progress = Math.round(
          (event.loaded * 100) / (event.total || event.loaded || 1)
        );
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params,
    };

    const uri = `${pics.mainAPI}${this.host}`;

    try {
      const res: AxiosResponse = await axios.post(uri, formData, config);
      if (res.status === 200) {
        this.$emit("updatePoster", res.data);
        this.$emit("input", res.data);
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.uploading = false;
      this.$refs.fileInput.value = "";
    }
  }
}
export default PosterEditor;
